// The Engage badge: the Engage roster request, filtered to unread conversations.
// Throws instead of returning a count it cannot prove, so the badge keeps its last good value.

import type { RosterScope } from '@/config/program';
import { getDashboard } from '../endpoints';
import { toDashboardParams } from './fetchView';

export async function getUnreadConversationCount({ role, ...scope }: RosterScope): Promise<number> {
  const body = await getDashboard(toDashboardParams(role, {
    ...scope,
    engagement: 'unread',
    // total_count is counted before the page slice, so one row is enough.
    pagination: { limit: 1 },
  }));
  const total = body?.meta?.total_count;
  if (typeof total !== 'number' || !Number.isFinite(total)) {
    throw new Error('getdashboard returned no total_count');
  }
  return total;
}
